import React, { useState, useEffect } from 'react';
import HeroHeadline from './HeroHeadline';
import './Hero.css';
import HeroBarHorizontal from './HeroBarHorizontal';

function Hero({approvedCount = 0, inProgressCount = 30, targetCount = 150}) {
  const [backgroundImage, setBackgroundImage] = useState('url("/thumbs/hero.png")');

  useEffect(() => {
    const img = new Image();
    img.src = '/images/hero_small.jpg';
    img.onload = () => {
      setBackgroundImage('url("/images/hero_small.jpg")');
    };
  }, []);

  return (
    <section className="hero" style={{ backgroundImage }}>
      <div className="hero-content">
        <div>
          <HeroHeadline approvedProjects={approvedCount} />
          <HeroBarHorizontal approved={approvedCount} inProgress={inProgressCount} target={targetCount} height={130} showInProgress={true}/>
        </div>
      </div>
    </section>
  );
}

export default Hero;
